export default __webpack_public_path__ + "static/media/eaton-logo.1a2a7e25.webp";